<div #devToolsContainer class="dev-tools" [class.open]="isOpen">
	@if (showToggleButton) {
		<button class="toggle-button" (click)="togglePanel()">
			<span [innerHTML]="isOpen ? '&larr;' : '&rarr;'"></span>
		</button>
	}

	<div class="heading-container">
		<h2 class="dev-tools-heading">Dev Tools</h2>
		<p class="description">
			Toggle DevTools with <b>"Control/Command+D"</b>
		</p>
	</div>

  <div class="dev-tools-content">
		<div class="dev-control theme-control">
			<h5 class="control-heading">Theme</h5>
			<select id="select-theme" (change)="onThemeChange($event)">
				@for (theme of themeOptions; track theme) {
					<option
						[value]="theme"
						[defaultSelected]="theme === themeService.theme.name"
					>
						{{ theme }}
					</option>
				}
			</select>
		</div>

		<div class="dev-control betslip-workbench-control">
			<h5 class="control-heading">Betslip workbench</h5>
			<p class="description">Limits, liability mock betslip. Edited limits and the player are kept across reloads.</p>
			<base-button class="button" variant="primary" (click)="openBetslipWorkbench()">
				Open workbench
			</base-button>
			<base-button class="button" variant="secondary" (click)="resetBetslipLimits()">
				Reset limits
			</base-button>
		</div>

		<div class="dev-control auth-control">
			<p>
				Logged in:
				<span
					class="auth-status"
					[class.unauthenticated]="!authService.isLoggedIn"
					[class.authenticated]="authService.isLoggedIn"
				>
					{{ authService.isLoggedIn }}
				</span>
			</p>
			<div>
				<base-button
					class="button"
					[loading]="authService.isLoading"
					[disabled]="authService.isLoggedIn"
					(click)="handleLogin()"
				>
					Log in
				</base-button>
				<base-button
					class="button"
					variant="secondary"
					[disabled]="!authService.isLoggedIn"
					[loading]="authService.isLoading"
					(click)="authService.logout()"
				>
					Log out
				</base-button>
			</div>
		</div>
			<div class="dev-control modal-control">
				<h5 class="control-heading">Modals v1</h5>
				<base-button class="button" variant="primary" (click)="openModalV1('default')">
					Default
				</base-button>
				<base-button class="button" variant="primary" (click)="openModalV1('logout')">
					Logout
				</base-button>
			</div>

			<div class="dev-control modal-control">
				<h5 class="control-heading">Modals v2</h5>
				<base-button class="button" variant="primary" (click)="openModalV2('text')">
					Text
				</base-button>
				<base-button class="button" variant="primary" (click)="openModalV2('template')">
					Template
				</base-button>
			</div>

			<div class="dev-control modal-control">
				<h5 class="control-heading">Auth prompt</h5>
				<base-button class="button" variant="primary" (click)="openAuthPrompt()">
					Login modal
				</base-button>
			</div>

			<div class="dev-control logger-control">
				<h5 class="control-heading">
					Logger modules
					<span class="logger-count">{{ loggerActiveCount() }} / {{ loggerTotalCount }} active</span>
				</h5>

				<input
					class="logger-filter"
					type="text"
					placeholder="Filter modules..."
					(input)="onLoggerFilterChange($event)"
				/>

				<div class="logger-actions">
					<base-button class="button" variant="secondary" (click)="enableAllLoggerModules()">
						All
					</base-button>
					<base-button class="button" variant="secondary" (click)="disableAllLoggerModules()">
						None
					</base-button>
					<base-button class="button" variant="secondary" (click)="resetLoggerModules()">
						Reset to env
					</base-button>
				</div>

				<div class="logger-modules">
					@for (group of loggerGroups(); track group.group) {
						<p class="logger-group">{{ group.group }}</p>
						@for (module of group.modules; track module.name) {
							<label class="logger-module" [class.active]="module.isActive">
								<input
									type="checkbox"
									[checked]="module.isActive"
									(change)="toggleLoggerModule(module.name)"
								/>
								{{ module.name }}
							</label>
						}
					} @empty {
						<p class="logger-empty">No modules match the filter.</p>
					}
				</div>
			</div>

    <!-- More dev controls/settings go here -->
  </div>
</div>


@if (showBetslipWorkbench) {
	<dt-betslip-workbench (closed)="showBetslipWorkbench = false" />
}

<!-- Modal projection for ModalServiceV2 -->
<ng-template #modalTitleTemplate>
	Template with components
</ng-template>
<ng-template #modalBodyTemplate>
	<base-button variant="primary" [style]="{'margin-right': '1rem'}">
		Base button
	</base-button>
	<base-button variant="secondary">
		Base button
	</base-button>
</ng-template>
